import { render, staticRenderFns } from "./PaymentsTable.vue?vue&type=template&id=69348b04&scoped=true&"
import script from "./PaymentsTable.vue?vue&type=script&lang=ts&"
export * from "./PaymentsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentsTable.vue?vue&type=style&index=0&id=69348b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69348b04",
  null
  
)

export default component.exports